export const GradoAcademicoOptions = [
    {text: 'Primaria', value: 'PR'},
    {text: 'Basicos', value: 'BA'},
    {text: 'Diversificado', value: 'DI'},
    {text: 'Universitario', value: 'UN'},
    {text: 'Maestría', value: 'MA'},
    {text: 'Doctorado', value: 'DR'},
    {text: 'No tiene', value: 'NO'},
]